var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    _vm.isGameView ? 'resize-page' : '',
    _vm.isLanding ? 'landing' : '',
    _vm.$route.name ? 'site-' + _vm.$route.name : '',
    ((_vm.isSpecialPage && !_vm.$store.getters['auth/isLoggedIn']) ||
      _vm.isManagementPage) &&
    _vm.smallWindow
      ? 'mobile-view'
      : '',
    _vm.$store.state.auth.acpMode ? 'acp-border position-relative' : '' ],attrs:{"id":"app"}},[(_vm.$store.state.auth.acpMode)?_c('span',{staticClass:"text-danger bold position-sticky",attrs:{"id":"acp-warning"}},[_vm._v(" ACHTUNG! ACP-Modus! Bitte achtsam verhalten und unbedingt wieder ausloggen! ")]):_vm._e(),(_vm.showFallBackPage)?_c('fall-back-page'):[_c('MainContent'),_c('broadcasting',{on:{"socketStatus":_vm.handleSocketStatus,"logout":_vm.handleLogout,"connectionLost":_vm.handleConnectionLost,"reconnected":_vm.handleReconnected,"tabResumed":_vm.handleTabResumed,"stateChange":_vm.handleConnectionStateChange}}),(_vm.isLoggedIn)?_c('connection-indicator',{attrs:{"state":_vm.connectionState}}):_vm._e(),(_vm.preloadContent)?_c('preloader'):_vm._e(),(_vm.isLoggedIn)?_c('pipeline'):_vm._e(),(_vm.isLoggedIn)?_c('global-popups'):_vm._e(),(
        _vm.isLoggedIn &&
        _vm.useV2Offers &&
        _vm.globalOfferData &&
        _vm.showGlobalOfferModal &&
        !_vm.showOfferChainModal &&
        (_vm.offerManualOpen ||
          (_vm.pipelineFinished &&
            !_vm.rewardPopupRunning &&
            !_vm.holdPipelineAfterPurchase))
      )?_c('modal-offer-dynamic',{attrs:{"offer-data":_vm.globalOfferData},on:{"hidden":_vm.onGlobalOfferHidden}}):_vm._e(),(
        _vm.isLoggedIn &&
        _vm.offerChainEnabled &&
        _vm.offerChainData &&
        _vm.showOfferChainModal
      )?_c('modal-offer-chain',{attrs:{"offer-data":_vm.offerChainData},on:{"hidden":_vm.onOfferChainHidden}}):_vm._e(),_c('CookieModal')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }